export const __GOIBIBO__: string = 'https://www.goibibo.com';

export const __VOYAGER__: string = 'https://voyager.goibibo.com';

export const __EXPLORER__: string = 'https://flights-explorer.makemytrip.com';
// export const __EXPLORER__: string =
//   __ENV_CONFIG__.ENV === 'dev'
//     ? 'http://10.66.79.29:8264'
//     : 'https://flights-explorer.makemytrip.com';

export const __PAGEMAKER_API__: string = 'http://hotels-goibibocms-pagemaker-web.ecs.mmt';

// export const __A_TO_B__: string = 'https://atob.goibibo.com';

export const __SERVER_A_TO_B__: string = 'http://flights-gi-backend.ecs.mmt';

export const __FLIGHTS_CALENDAR__: string = 'http://flights-calendar.ecs.mmt';

export const __SEO__: string = 'https://seo.goibibo.com';

export const __MAPI__: string = 'http://hcs-gi-mapi.ecs.mmt';

export const __GI_CB__: string = __ENV_CONFIG__.GI_CB;
export const __INTERNAL_GI_CB__: string = __ENV_CONFIG__.INTERNAL_GI_CB;

export const __ENV__: string = __ENV_CONFIG__.ENV;

export const IS_MWEB_LITE: string = __ENV_CONFIG__.IS_MWEB_LITE;

// API

export const HOLIDAY_API = `${__MAPI__}/mobile-core-api-web/api/holidayCalendar/v1/`;

export const EXPLORER_AUTOSUGGEST: string = `${__EXPLORER__}/autosuggest`;

export const FLIGHT_STATUS_URL: string = `${__GOIBIBO__}/flights/flight-status/`;

export const OFFERS_API_URL: string = `${__VOYAGER__}/api/v1/pagemaker/get_personalized_chunk_offers_data/?chunk=home_carousel&flavour=mobile&vertical=flight&include_fields=["url","img_url","sub_heading","validity_text","slug"]&mode=app`;

export const OFFERS_API_SERVER_URL: string = `${__PAGEMAKER_API__}/api/v1/pagemaker/get_personalized_chunk_offers_data/?chunk=home_carousel&flavour=mobile&vertical=flight&include_fields=["url","img_url","sub_heading","validity_text","slug"]&mode=app`;

export const OFFERS_API_SERVER_URL_INTL: string = `${__PAGEMAKER_API__}/api/v1/pagemaker/get_chunk_offers_data/?chunk=home_carousel&flavour=v3&vertical=intlflight&include_fields=["url","img_url","sub_heading","validity_text","slug"]&mode=app`;

export const FARE_CALENDAR_API_URL: string = `${__GI_CB__}/minfare/v2/web/`;
export const SERVER_FARE_CALENDAR_API_URL: string = `${__SERVER_A_TO_B__}/minfare/v2/web/`;

export const ALTERNATE_FLIGHT_OPTIONS_URL = `${__GI_CB__}/flight/suggestions`;

export const SEO_URL: string = `${__SEO__}/api/v1/flights/get_flight_sector_data/`;

export const SUBMIT_URL: string = `${__GI_CB__}/submit/`;

export const SUBMIT_V2_URL: string = `${__GI_CB__}/v2/submit`;

export const VALIDATE_FORM_URL: string = `${__GI_CB__}/validate-form/`;

export const VALIDATE_FORM_V2_URL: string = `${__GI_CB__}/traveller-submit`;

export const VALIDATE_SINGLE_TRAVELLER_URL: string = `${__GI_CB__}/validate-traveller-info`;

export const PETHOES_API_URL: string = `${__GI_CB__}/v2/thor/rest/flight/getPethoesResponse/`;

export const INTERNAL_PETHOES_API_URL: string = `${__INTERNAL_GI_CB__}/v2/thor/rest/flight/getPethoesResponse/`;

// PAGE URLS

export const FLIGHTS_URL = '/flights/';

export const AUTOSUGGEST_PAGE_URL: string = `${FLIGHTS_URL}autosuggest/`;

export const CALENDAR_PAGE_URL: string = `${FLIGHTS_URL}calendar/`;

export const PAX_PAGE_URL: string = `${FLIGHTS_URL}pax/`;

export const FLIGHT_CLASS_PAGE_URL: string = `${FLIGHTS_URL}class/`;

export const SRP_URL: string = `${FLIGHTS_URL}air-`;

export const DESTINATION_PICKER_URL: string = `${FLIGHTS_URL}destinationPicker`;

export const FARES_URL: string = `${FLIGHTS_URL}fares/`;

export const FILTERS_URL: string = `${FLIGHTS_URL}filters/`;

export const FILTERS_lITE_URL: string = `${FLIGHTS_URL}filters/`;

export const NO_FLIGHTS_LITE_URL: string = `${FLIGHTS_URL}noflights/`;

export const ALTERNATE_URL: string = `${FLIGHTS_URL}alternate/`;

// export const BOOKING_REVIEW_PAGE_URL: string = IS_MWEB_LITE ? `${NEW_FLIGHTS_URL}flight-review/` : '/flight-review/';
export const BOOKING_REVIEW_PAGE_URL: string = '/flight-review/';

export const __SEAT_URL__: string = __ENV_CONFIG__.BASE_URL + '/seat/?';

export const __CHUNK_URL__ = `${__GI_CB__}/getchunkdata/`;

export const __INTERNAL_CHUNK_URL__ = `${__INTERNAL_GI_CB__}/getchunkdata/`;

export const __EXTRA_SEAT_INFO_URL__: string = `${__CHUNK_URL__}?key=extra_seat_chunk`;

export const __ADTECH_INFO_URL__: string = `${__CHUNK_URL__}?key=srp_ad_banner`;

export const AIRLINE_INFO_URL: string = `${__GI_CB__}/getchunkdata/?key=travelers_chunk`;

export const __SERVER_DESTINATION_INFO_URL__: string = `${__SERVER_A_TO_B__}/flight/ifpicker/destinations`;

export const __DESTINATION_INFO_URL__: string = `${__GI_CB__}/flight/ifpicker/destinations`;

export const __AIRPORT_INFO_URL__: string = `${__EXPLORER__}/fetch_airport_info`;

export const ZC_PRICE_INFO_URL: string = `${__GI_CB__}/zc-fare-rules/`;

export const __MWEB_TO_APP_CHUNK_URL__: string = `${__CHUNK_URL__}?key=mweb_app_srp`;

export const __MWEB_TO_APP_CHUNK_URL_SERVER__: string = `${__INTERNAL_CHUNK_URL__}?key=mweb_app_srp`;

export const PDT_URL = `${__GI_CB__}/v1/thor/rest/flight/home/fast-search`;

export const OUR_PROMISES_AND_USER_STORIES_URL: string = `${__GI_CB__}/v1/thor/rest/flight/home/chunk-data?key=our_promises,user_stories`;

export const POKUS_EXPERIMENT_URL: string = 'https://pokus.goibibo.com/experiment/assignVariant';

export const THANK_YOU_PAGE_API_URL: string = `${__GI_CB__}/v2/hulk/transaction-middleware`;

export const SURVEY_URL: string = 'https://mapi.makemytrip.com/surveymgmt/v1/';

export const SURVEY_RESPONSE_URL: string = `${SURVEY_URL}surveyresponse/uniqueId/`;

export const CREATE_SURVEY_URL: string = `${SURVEY_URL}commonnps/createDesktopSurvey/`;

export const OMNITURE_INFO_URL: string = `${__GI_CB__}/gi-analytics/`;
export const OMNITURE_INFO_URL_SERVER: string = `${__INTERNAL_GI_CB__}/gi-analytics/`;

export const PRICE_LOCK_BANNER_URL: string = `${__CHUNK_URL__}?key=fare_lock_banner_details`;

export const PRICE_LOCK_OVERLAY_URL: string = `${__CHUNK_URL__}?key=fare_lock_premium`;

export const PRICE_LOCK_REVIEW_URL: string = `${__GI_CB__}/farelock-review/`;
export const PRICE_LOCK_MULTI_REVIEW_URL: string = `${__GI_CB__}/farelock-multi-review/`;

export const PRICE_LOCK_PRE_BOOK_URL: string = `${__GI_CB__}/farelock-prebook/`;
// export const OMNITURE_INFO_URL: string = `http://10.66.39.242:8040/gi-analytics/`; // For DEV testing
// export const OMNITURE_INFO_URL_SERVER: string = `http://10.66.39.242:8040/gi-analytics/`;

// export const __CSSHOST__: string =
//   __ENV_CONFIG__.ENV === 'prod'
//     ? 'https://goibibo.ibcdn.com/styleguide/css/'
//     : `${__ENV_CONFIG__.BASE_URL}/styleguide/css/`;

export const SEARCH_URL = `${__GI_CB__}/search/v2/`;

export const SEO_BUS_API = `http://cabs-pagerover.ecs.mmt/gt_bus/api/v1/interlink_bus_seo_data/?page=route`;
export const SEO_RAILS_API = `http://cabs-pagerover.ecs.mmt/gt_rail/api/v1/get_interlink_data/?page=city`;
export const SEO_CABS_API = `http://cabs-pagerover.ecs.mmt/gt_cab/api/v1/cabs_interlinks_data/?page=route`;
export const SEO_HOTELS_API = `http://hotels-gi-seo.ecs.mmt/seo-api/hotels/api/v1/crossLob?lob=FLIGHT&brand=GI&type=name`;

export const ICON_BASE_URL: string = 'https://imgak.goibibo.com/flights-gi-assets/images/';
export const ICON_BASE_APP_URL: string = `${ICON_BASE_URL}/appImg/`;

export const EASY_VISA_DESTINATION_URL = `${__GI_CB__}/v1/thor/rest/flight/home/easy-visa-destinations`;
export const COMBINED_FLIGHTS_PERSUASION = `${__GI_CB__}/search/combo-selection`;
